import {
    KM_PER_MILE,
    M_TO_FT,
    MINUTES_PER_HOUR,
    BYTES_PER_MB,
    HANDS_TO_METER,
    LBS_TO_KG,
    KG_TO_LBS,
    METER_TO_HANDS,
    MILE_PER_METER
} from '../constants';

export function kilometersToMiles(k: number): number {
    const result = k / KM_PER_MILE;
    return isNaN(result) || !isFinite(result) || result < 0 ? 0 : result;
}

export function metersToFeet(meters: number): number {
    const result = meters * M_TO_FT;
    return isNaN(result) || !isFinite(result) || result < 0 ? 0 : result;
}

export function minutesToHours(m: number): number {
    return m / MINUTES_PER_HOUR;
}

export function bytesToMB(bytes: number): number {
    return bytes / BYTES_PER_MB;
}

export function milesToKilometers(k: number): number {
    return k * KM_PER_MILE;
}

export function milesToMeters(m: number): number {
    return m * MILE_PER_METER;
}

export function handsToMeter(h: number): number {
    return h * HANDS_TO_METER;
}

export function lbsToKg(l: number): number {
    return l * LBS_TO_KG;
}

export function meterToHands(m: number): number {
    if(m){
        return m * METER_TO_HANDS;
    } else {
        return 0.00
    }
}

export function kgToLbs(l: number): number {
    if(l){
        return l * KG_TO_LBS;
    } else {
        return 0.00
    }
}
